import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * FreeRoundsInfoBannerLocation.ts
 */
export var FreeRoundsInfoBannerLocation;
(function (FreeRoundsInfoBannerLocation) {
    FreeRoundsInfoBannerLocation["LEFT"] = "LEFT";
    FreeRoundsInfoBannerLocation["BOTTOM"] = "BOTTOM";
    FreeRoundsInfoBannerLocation["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(FreeRoundsInfoBannerLocation || (FreeRoundsInfoBannerLocation = {}));
/**
 * AbstractFreeRoundsInfoBannerProperties.ts
 */
export class AbstractFreeRoundsInfoBannerProperties extends AbstractViewProperties {
    constructor(position, bannerType) {
        super();
        this.position = position;
        this.type = bannerType;
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.headerTextColor = "#ffffff";
        this.headerBackgroundColor = "#00b1b6";
        this.contentTextColor = "#00b1b6";
        this.contentBackgroundColor = "#ffffff";
    }
}
//# sourceMappingURL=AbstractFreeRoundsInfoBannerProperties.js.map